// extracted by mini-css-extract-plugin
export default {"ButtonPlaceholder":"ob8S9IB8","ButtonSkeleton":"drmiIbDN","IconPlaceholder":"Z1tkG_kE","Prefix":"H4jv8TKe","Suffix":"lhWbh7lm","Control":"uJE8SK_r"};